function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".location-thin_svg__st0{fill:none;stroke:#000;stroke-width:inherit;stroke-linejoin:round;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "location-thin_svg__st0",
  d: "M4.8 2.7c-.8 0-1.5.7-1.5 1.5S4 5.7 4.8 5.7 6.3 5 6.3 4.2s-.7-1.5-1.5-1.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "location-thin_svg__st0",
  d: "M4.8.2c-2 0-3.6.9-4.2 2.4C0 4-.3 7 4.4 11.5c.1.1.2.2.4.2.1 0 .3-.1.4-.2C9.9 7 9.6 4 9.1 2.7 8.4 1.2 6.8.2 4.8.2z"
});

function SvgLocationThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location-thin_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 9.6 11.9",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgLocationThin;